import React from 'react';
typeof window !== 'undefined' && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = '2.10.0');
import ImageCarousel from '../ImageCarousel';
import { useUniqueId } from '../../hooks/useUniqueId';
import { Title, Price, PriceInfo, OldPrice, Subtitle, SellerDetails, Location, FavoriteButton, Labels, Badges, LinkWrapper } from './components';
import useWindowSize from '../../hooks/useWindowSize';
import * as Styles from './styles';
/**
 * Componente AdCard do Design System OLX
 */
export const AdCard = _ref => {
  let {
    isCarrouselDisabled = false,
    mode = 'horizontal',
    isSlimCard = false,
    listId,
    imageBadge,
    isHighlight,
    title,
    subtitle,
    adDetails,
    images,
    showDisabledButton,
    videos,
    priceInformation,
    price,
    oldPrice,
    badgeGroup,
    headBadge,
    onlineStatus,
    professionalAd,
    location,
    showLocationMapPin = true,
    date,
    adUrl,
    adUrlTarget = '_blank',
    imagesCount = 0,
    videoCount = 0,
    isFavorited,
    showFavoriteButton = true,
    imageLoadingStrategy = 'lazy',
    showImagesCounter = true,
    showVideosCounter = true,
    displayMoreContentOverlay,
    onClick,
    onAuxClick,
    favoriteHandler,
    previousImageHandler,
    nextImageHandler,
    className,
    link,
    forceSmallScreenLayout
  } = _ref;
  var _a, _b, _c;
  const {
    width
  } = useWindowSize();
  const isMobile = width < 566;
  const isSmallScreen = isMobile || forceSmallScreenLayout;
  const hasImages = (images === null || images === void 0 ? void 0 : images.length) > 0;
  const isVerticalSlimCard = mode === 'vertical' && isSlimCard;
  const onFavoriteClick = event => {
    event.stopPropagation();
    event.preventDefault();
    favoriteHandler && favoriteHandler(listId);
  };
  const titleID = useUniqueId('ds-adcard-title');
  let returnImage = new Array();
  if (hasImages) {
    returnImage = isCarrouselDisabled ? [{
      alt: (_a = images[0]) === null || _a === void 0 ? void 0 : _a.originalAlt,
      url: (_b = images[0]) === null || _b === void 0 ? void 0 : _b.original,
      urlWebP: (_c = images[0]) === null || _c === void 0 ? void 0 : _c.originalWebP
    }] : images.map(image => ({
      alt: image === null || image === void 0 ? void 0 : image.originalAlt,
      url: image === null || image === void 0 ? void 0 : image.original,
      urlWebP: image === null || image === void 0 ? void 0 : image.originalWebP
    }));
  }
  return React.createElement(Styles.Wrapper, {
    "data-ds-component": "DS-AdCard",
    className: "".concat(isHighlight ? 'isHighlight' : '', " ").concat(mode, " ").concat(className),
    isVerticalSlimCard: isVerticalSlimCard
  }, React.createElement(LinkWrapper, {
    adUrl: adUrl,
    adUrlTarget: adUrlTarget,
    onClick: onClick,
    onAuxClick: onAuxClick,
    titleID: titleID
  }), React.createElement(ImageCarousel, {
    isSmallScreen: isSmallScreen && mode === 'horizontal',
    imageList: returnImage,
    isCarrouselDisabled: isCarrouselDisabled,
    totalCarouselImages: showImagesCounter ? imagesCount : 0,
    totalCarouselVideos: showVideosCounter ? videoCount : 0,
    badge: imageBadge,
    showDisabledButton: showDisabledButton,
    loading: imageLoadingStrategy,
    displayMoreContentOverlay: displayMoreContentOverlay,
    previousImageHandler: previousImageHandler,
    nextImageHandler: nextImageHandler
  }), React.createElement(Styles.Content, {
    className: "".concat(mode),
    "data-testid": "ds-adcard-content",
    isVerticalSlimCard: isVerticalSlimCard
  }, React.createElement(Styles.Top, {
    className: mode
  }, React.createElement(Styles.DetailsAds, {
    className: mode
  }, React.createElement(Subtitle, null, subtitle), React.createElement(Title, {
    adUrl: adUrl,
    titleID: titleID,
    adUrlTarget: adUrlTarget,
    mode: mode
  }, title), mode === 'horizontal' && isMobile && React.createElement(Price, {
    mode: mode,
    priceMobile: true
  }, price), React.createElement(Labels, {
    width: width
  }, adDetails), (mode === 'horizontal' && !isMobile || mode === 'vertical' || isMobile && (!subtitle || !adDetails)) && React.createElement(Badges, {
    headBadge: headBadge,
    width: width
  }, badgeGroup)), React.createElement(Styles.DetailsPrice, {
    className: mode
  }, React.createElement(OldPrice, {
    mode: mode
  }, oldPrice), React.createElement(Price, {
    mode: mode
  }, price), React.createElement(PriceInfo, {
    mode: mode
  }, priceInformation))), React.createElement(Styles.Bottom, {
    className: mode
  }, React.createElement(Styles.DetailsAndLocation, null, React.createElement(SellerDetails, {
    isProfessionalAd: professionalAd,
    isOnline: onlineStatus
  }), React.createElement(Location, {
    mode: mode,
    date: date,
    showLocationMapPin: showLocationMapPin
  }, location)))), React.createElement(FavoriteButton, {
    isFavorited: isFavorited,
    onFavoriteClick: onFavoriteClick
  }, showFavoriteButton));
};
AdCard.displayName = 'AdCard';